import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const repairLocationTypesAdapter = getAdapter({ idFieldName: 'value' });

const repairLocationTypesSlice = createSlice({
  name: 'repairLocationTypes',
  initialState: repairLocationTypesAdapter.getInitialState(),
  reducers: {
    setRepairLocationTypes: (state, { payload: { repairLocationTypes } }) => {
      repairLocationTypesAdapter.setAll(state, repairLocationTypes);
    },
  },
});

const selectors = repairLocationTypesAdapter.getSelectors(
  ({ repairLocationTypes }) => repairLocationTypes,
);

export const getRepairLocationTypes = (state) => selectors.selectAll(state);

export const { setRepairLocationTypes } = repairLocationTypesSlice.actions;

export default repairLocationTypesSlice.reducer;
